import type { CareerPath } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

const EXCLUDED_KEYS = new Set(['career_category_id', 'career_category_img']);

export const useAgentContext = (careerPath: CareerPath) => {
  useRegisterAgentContext({
    kind: 'entity',
    description: 'The career path the user is viewing',
    data: Object.fromEntries(Object.entries(careerPath).filter(([k]) => !EXCLUDED_KEYS.has(k))),
  });
};
